// extracted by mini-css-extract-plugin
export default {"cls1":"_ODXaXMX3Cv11PupHjUQ","cls2":"NfjjUp6hBrVje1eggwtZ _ODXaXMX3Cv11PupHjUQ"};